import { ReactNode } from 'react';

/** Rótulo visível dos filtros das listas (ciclo, mês): caixa alta, 11px, acima do seletor. */
export default function RotuloDeFiltro({ htmlFor, children }: { htmlFor: string; children: ReactNode }) {
  return (
    <label htmlFor={htmlFor} className="mb-[7px] block text-[11px] font-bold uppercase tracking-[0.05em] text-content-soft">
      {children}
    </label>
  );
}
